import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import faq from './faq';

const Applications = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/`} />
      <Route path={`${match.url}/dashboards`} component={faq} />
      <Redirect to="/error" />
    </Switch>
  </div>
);
export default Applications;
